const initialState = {
    selectedBoatType: null,
    filterFields: {},
    filter: {
        distances: [],
        times: [],
        speedIntensities: [],
        hrIntensities: [],
        srIntensities: [],
        boatTypes: [],
        tags: [],
        focuses: []
    }
};

export const reportsRowing = {
    namespaced: true,

    state: Object.assign({}, initialState),

    getters: {
        filterFields(state) {
            return state.filterFields;
        },

        filter(state) {
            return state.filter;
        },

        selectedBoatType(state) {
            return state.selectedBoatType;
        }
    },

    mutations: {
        resetState(state) {
            state = Object.assign({}, initialState);
        },

        setFilterFields(state, payload) {
            state.filterFields = payload;
        },

        setTags(state, payload) {
            state.filter.tags = payload;
        },

        setSelectedBoatType(state, payload) {
            state.selectedBoatType = payload;
        },

        setDistance(state, payload) {
            state.filter.distances = payload;
        },

        setTime(state, payload) {
            state.filter.times = payload;
        },

        setBoatType(state, payload) {
            state.filter.boatTypes = payload;
        },

        setSpeedIntensity(state, payload) {
            state.filter.speedIntensities = payload;
        },

        setHrIntensity(state, payload) {
            state.filter.hrIntensities = payload;
        },

        setSrIntensity(state, payload) {
            state.filter.srIntensities = payload;
        },

        setFocus(state, payload) {
            state.filter.focuses = payload;
        }
    }
};

export default reportsRowing;
